import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ScrollLockDirective } from "./scroll-lock.directive";

@NgModule({
  declarations: [ScrollLockDirective],
  imports: [CommonModule],
  providers: [ScrollLockDirective],
  exports: [ScrollLockDirective],
})
export class ScrollLockModule {}
